import { useEffect } from 'react'
import { useData } from '../DataProvider'

const API = 'https://adsapi.tribesportsapp.com/api/'

export const useDataFetch = (path: string, key: string) => {
  const { setData, data } = useData()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(API + path)
        const res = await response.json()
        console.log('use data fetch::', key, res)
        if (key === 'channels') {
          setData((prevData: any) => ({
            ...prevData,
            teams: [...(prevData?.teams || []), ...res.teams],
            leagues: [...(prevData?.leagues || []), ...res.leagues],
            matches: [...(prevData?.matches || []), ...res.matches],
          }))
        } else {
          setData((prevData: any) => ({ ...prevData, [key]: res }))
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (!data || !data[path]) {
      fetchData()
      setData((prevData: any) => ({...prevData, [path]: 'loading'}))
    }
  }, [path, key, setData, data])
}

